<template>
  <Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
    <h2>Share</h2>
    <p>Each link provides different capabilities.</p>
    <form
      class="Share_Form PForm"
      v-on:click.stop
      v-for="(shareLink, index) in shareLinks"
      :key="shareLink.accessLevel"
    >
      <p>
        <strong>{{ getTitle(shareLink.accessLevel) }}:</strong>
        {{ getDescription(shareLink.accessLevel) }}
      </p>
      <div class="InputAndCopy">
        <input
          ref="textInput"
          class="Share_Link"
          type="text"
          :value="shareLink.url"
          v-on:click="selectInput(index)"
        />
        <CopyButton :text="shareLink.url"></CopyButton>
      </div>
    </form>
    <div class="ButtonRow_Right">
      <button class="WBMBigButton" v-on:click="onDone">Done</button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Ref, Component, Emit } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import CopyButton from "@/components/CopyButton.vue";
import { WBState } from "@/store/stateInterfaceType";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal, CopyButton } })
export default class ShareModal extends WBComponent {
  @Ref() textInput!: HTMLInputElement[];
  copiedURLs = new Set<string>();

  get shareLinks(): Array<{ accessLevel: string; url: string }> {
    const result = Array<{ accessLevel: string; url: string }>();

    const shareURLs = (this.state as WBState).shareURLs;
    for (const [k, v] of Object.entries(shareURLs)) {
      result.push({ accessLevel: k, url: `${window.location.origin}${v}` });
    }

    return result;
  }

  @Emit("done")
  onDone() {
    ModalMutations.closeModals(this.$store.commit);
  }

  onCopy(_e: UIEvent, text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        const newURLs = new Set(this.copiedURLs);
        newURLs.add(text);
        this.copiedURLs = newURLs; // trigger reactivity
      })
      .catch(() => {
        alert(
          "Copy failed. This can happen if the browser window was out of focus. Try again."
        );
      });
  }

  isCopied(text: string): boolean {
    return this.copiedURLs.has(text);
  }

  selectInput(i: number) {
    this.textInput[i].setSelectionRange(0, this.textInput[i].value.length);
  }

  getTitle(accessLevel: string): string {
    switch (accessLevel) {
      case "view":
        return "View";
      case "contribute":
        return "Contribute";
      case "admin":
        return "Owner";
      default:
        return "";
    }
  }

  getDescription(accessLevel: string): string {
    switch (accessLevel) {
      case "view":
        return "They can see everything, but not make any changes.";
      case "contribute":
        return "They can see everything and make changes, but not clear the board.";
      case "admin":
        return "They can do everything you can do.";
      default:
        return "";
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin-top: 0;
}

.ButtonRow_Right {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > * {
    display: block;
  }
}

.InputAndCopy {
  display: flex;
  margin-bottom: 1rem;

  input {
    margin-right: var(--margin-tiny);
    height: 36px;
  }
}

.Share_Link {
  width: 100%;
  flex-grow: 100;
}

.Share_Form .WBMBigButton {
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 1rem;
}
</style>
